import { combineReducers } from 'redux';
import site from 'composer-blocks/lib/reducers/site';
import pages from './pages';
import blocks from './blocks';
import navbars from './navbars';
import footers from './footers';
import contents from './contents';
import otherData from './otherData';
import pageOrder from './pageOrder';
import properties from './properties';
import globalSettings from './globalSettings';

const composerApp = combineReducers({
  site,
  pages,
  blocks,
  navbars,
  footers,
  contents,
  otherData,
  pageOrder,
  properties,
  globalSettings,
});

export default composerApp;
